// Navigation utilities for React Router v6
// This provides navigation functionality for sagas and other non-component contexts

let navigate = null;

export const setNavigate = navigateFunction => {
  navigate = navigateFunction;
};

export const push = path => {
  if (navigate) {
    navigate(path);
  } else {
    // Fallback to window.location for cases where navigate is not available
    window.location.href = path;
  }
};

export const replace = path => {
  if (navigate) {
    navigate(path, { replace: true });
  } else {
    // Fallback to window.location
    window.location.replace(path);
  }
};
